import { TaskCardStatus } from "../models";

export const STATUS_LABELS: Record<TaskCardStatus, string> = {
  unassigned: "Unassigned",
  "not-started": "Not started",
  "in-progress": "In progress",
  "in-review": "In review",
  completed: "Completed",
  blocked: "Blocked",
  overdue: "Overdue",
};

export const STATUS_MODIFIER: Record<TaskCardStatus, string> = {
  unassigned: "TaskCard_statusTag_unassigned",
  "not-started": "TaskCard_statusTag_notStarted",
  "in-progress": "TaskCard_statusTag_inProgress",
  "in-review": "TaskCard_statusTag_inReview",
  completed: "TaskCard_statusTag_completed",
  blocked: "TaskCard_statusTag_blocked",
  overdue: "TaskCard_statusTag_overdue",
};

export const UNASSIGNED_ASSIGNEE_LABEL = "Unassigned";

/** Shown in place of the deadline when a task has none. */
export const NO_DUE_DATE_LABEL = "-";
